import axios from "axios"

const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const getNotificationAPI = async () => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(`${apiBaseUrl}/get-Notifications`, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}


export const sendNotificationAPI = async (payload) => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/send-notification-mail`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}


export const deleteNotificationAPI = async (payload) => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    if (payload.notiType === 'lead') {
      return await axios.post(`${apiBaseUrl}/removeLeadsFollowpNotification`, { "Lead_id": payload.notiId }, {
        headers,
      })
    } else {
      return await axios.post(`${apiBaseUrl}/removeCustomerFollowupNotification`, { "customer_id": payload.notiId }, {
        headers,
      })
    }

  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}


export const sendEmpMailAPI = async (payload) => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/send-EmployeeMail`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error Sending Employee notification mail:", error)
    throw error
  }
}